import {
  RECEIVE_NOTIFICATIONS,
  HIDE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  MARK_ALL_AS_READ,
  RECEIVE_PUSH_NOTIFICATION,
  TOGGLE_DO_NOT_DISTURB,
  INITIALIZE_DO_NOT_DISTURB
} from './types';

export function receiveNotifications(notificationList, unreadCount) {
  return ({
    type:    RECEIVE_NOTIFICATIONS,
    payload: { notificationList, unreadCount }
  });
}

export function receivePushNotification(notification) {
  return ({
    type:    RECEIVE_PUSH_NOTIFICATION,
    payload: { notification }
  });
}

export function hideNotification(notification) {
  return (dispatch, getState, notificationAPI) => {
    notificationAPI.update(notification.id, { active: false })
      .catch(() => {});
    dispatch({
      type:    HIDE_NOTIFICATION,
      payload: { id: notification.id }
    });
  };
}

export function markNotificationRead(notification) {
  return (dispatch, getState, notificationAPI) => {
    if (notification.unread) {
      notificationAPI.update(notification.id, { unread: false })
        .catch(() => {});
      dispatch({
        type:    MARK_NOTIFICATION_READ,
        payload: { id: notification.id }
      });
    }
  };
}

export function markAllAsRead() {
  return (dispatch, getState, notificationAPI) => {
    if (getState().unreadCount > 0) {
      notificationAPI.markAllAsRead()
        .catch(() => {});
      dispatch({
        type: MARK_ALL_AS_READ
      });
    }
  };
}

export function toggleDoNotDisturb(doNotDisturbEnabled) {
  return (dispatch, getState, notificationAPI) => {
    notificationAPI.updateDoNotDisturb(!doNotDisturbEnabled)
      .catch(() => {});
    dispatch({
      type: TOGGLE_DO_NOT_DISTURB
    });
  };
}

export function initializeDoNotDisturb(doNotDisturbEnabled) {
  return ({
    type: INITIALIZE_DO_NOT_DISTURB,
    payload: { doNotDisturbEnabled: doNotDisturbEnabled }
  });
}

export function fetchNotifications() {
  return (dispatch, _, notificationAPI) => {
    notificationAPI.fetch()
      .then((response) => {
        dispatch(receiveNotifications(response.notificationList, response.unreadCount));
      }).catch(() => {});
  };
}
